import {
  formatCurrency,
} from "helpers";
import { FleetVehicleOfferSaleItemRow } from "services/api/fleet/vehicles/offers/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_OFFER_ITEMS_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleEditClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {


  return [
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.code",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md min-h-[40px] flex items-center font-light text-slate-500">{row.code}</div>
        );
      },
    },
    {
      title: "Vrsta",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.billingItemTypeName ?? "-"}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">{row.name}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.taxrate",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.taxRate} %</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.quantity",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">{row.quantity} {row.unitOfMeasureId ?? "kom"}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.pricewithouttax",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">
            {formatCurrency.format(row.priceWithoutTax)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.pricewithtax",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {formatCurrency.format(row.priceWithTax)}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.discount",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md font-light text-slate-500">
            {formatCurrency.format(row.discountAmount)}
          </div>
        );
      },
    },
    //  {
    //   title: "admin.fleet.vehicle.offer.sale.item.added.discount.percentage",
    //   field: "",
    //   type: ColumnTypes.custom,
    //   render: (row) => {
    //     return (
    //       <div className="text-md">{row.discountPercentage} %</div>
    //     );
    //   },
    // },
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.total",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md ">
            {formatCurrency.format(row.total)}
          </div>
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleOfferSaleItemRow) => {
        return (
          <>
            <ButtonMenu
              endIcon="/media/icons/more-dots.svg"
              cssClassName="h-full"
              variant="text"
            >
              <ButtonMenuItem
                startIcon="/media/icons/edit.svg"
                onClick={(e) => handleEditClick(e, row.id)}
              >
                Ažuriraj
              </ButtonMenuItem>
              <ButtonMenuItem
                startIcon="/media/icons/trash.svg"
                variant="remove"
                onClick={(e) => handleDeleteClick(e, row.id)}

              >
                Obriši
              </ButtonMenuItem>
            </ButtonMenu>
          </>
          // <div className="flex gap-2">
          //   <span onClick={(e) => handleEditClick(e, row.id)} className="block w-10 h-10 flex items-center justify-center cursor-pointer bg-blue-50 hover:bg-blue-100 rounded-full" >
          //     <ReactSVG
          //       src={"/media/icons/edit.svg"}
          //       className="w-4 h-4 stroke-blue-700"
          //     />
          //   </span>
          //   <span onClick={(e) => handleDeleteClick(e, row.id)} className="block w-10 h-10 flex items-center justify-center cursor-pointer bg-red-50 hover:bg-red-100 rounded-full" >
          //     <ReactSVG
          //       src={"/media/icons/trash.svg"}
          //       className="w-4 h-4 stroke-[#bd0000]"
          //     />
          //   </span>
          // </div>
        );
      },
    },
  ];
};





export const FLEET_VEHICLE_OFFER_ITEMS_CHILD_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "admin.fleet.vehicle.offer.sale.item.added.note",
      field: "note",
      type: ColumnTypes.string,
    },

  ];



